<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
export default {
  name: 'mp-draw2-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      width: 0,
      height: 0,
      offset: {},
      stage: {},
      figureArea: {},
      touchArea: {},
      line: {},
      mousedown: false,
      images: [],
      point: {},
      lines: [],
    };
  },
  beforeMount() {},
  mounted() {
    this.initData = this.startGameConfig;
    this.stage = new createjs.Stage('gameCanvas');
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;
    this.initGame();
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    setStage() {
      this.width = document.getElementById('game-container').offsetWidth;
      this.height = document.getElementById('game-container').offsetHeight;

      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };

      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
    },
    loadImages() {
      var self = this;
      let pick = this.initData.pick
        ? this.initData.pick > this.initData.sample[0].length
          ? this.initData.sample[0].length
          : this.initData.pick
        : this.initData.sample[0].length;
      let shuffle = this.initData.shuffle ? true : false;
      var groups = [];
      var indx = [];
      if (shuffle) {
        for (let i = 0; i < pick; i++) {
          let ix = Math.round(Math.random() * (this.initData.sample[0].length - 1));
          let flg = false;
          for (let j = 0; j < indx.length; j++) if (indx[j] == ix) flg = true;
          if (flg) i--;
          else indx[i] = ix;
        }
      } else indx = Array.from({ length: pick }, (v, k) => k);

      for (let i = 0; i < this.initData.sample.length; i++) {
        groups[i] = [];
        this.images[i] = [];
      }

      indx.forEach(function (ind, i) {
        for (let j = 0; j < groups.length; j++) {
          groups[j][i] = Object.assign({}, self.initData.sample[j][ind]);
        }
      });
      for (let i = 1; i < groups.length; i++) {
        groups[i] = this.shuffle(this.shuffle(groups[i]));
      }

      var manifest = [];
      groups.forEach(function (gr, i) {
        gr.forEach(function (img, j) {
          img.gr = i;
          img.dim = self.initData.version.dim;
          img.cord = {};
          if (self.initData.version.isHor) {
            img.cord.y = self.initData.version.cord[i].y;
            img.cord.x = self.initData.version.cord[i].x + (self.initData.version.cord[i].x + img.dim.w) * j;
          }

          manifest.push(img);
        });
      });

      let queue = new preload.LoadQueue();
      queue.on('fileload', this.handleFileLoad);
      queue.on('complete', this.handleComplete);
      queue.loadManifest(manifest);
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    initGame() {
      this.resetCheckStatus();
      this.setStage();
      this.loadImages();

      var self = this;
      this.point = new createjs.Shape();
      this.point.graphics.beginFill('rgba(0,0,0,0.3)').drawCircle(0, 0, 25);
      this.point.on('pressmove', function (e) {
        e.target.x = e.stageX - self.offset.x;
        e.target.y = e.stageY - self.offset.y;
        self.update();
      });
      this.point.start = { gr: 0, i: 0 };
      this.point.visible = false;
      this.line = new createjs.Shape();
      this.stage.update();
    },
    newGame() {
      this.mousedown = false;
      this.stage.removeAllChildren();
      this.stage.removeAllEventListeners();

      for (let i = 0; i < this.lines.length; i++) {
        this.stage.removeChild(this.lines[i].shape);
      }
      this.lines.splice(0, this.lines.length);

      this.initGame();
      this.stage.update();
    },
    handleFileLoad(e) {
      var image = e.result;
      var w = image.width;
      var h = image.height;
      let bmp = new createjs.Bitmap(image.src);

      bmp.id = e.item.id;
      bmp.correct = e.item.correct;
      bmp.block = false;
      bmp.x = -this.width / 2 + e.item.cord.x;
      bmp.y = -this.height / 2 + e.item.cord.y;

      if (e.item.dim.w && e.item.dim.h) {
        bmp.scaleX = e.item.dim.w / w;
        bmp.scaleY = e.item.dim.h / h;
      } else if (e.item.dim.w && !e.item.dim.h) {
        bmp.scaleX = bmp.scaleY = e.item.dim.w / w;
      } else if (!e.item.dim.w && e.item.dim.h) {
        bmp.scaleX = bmp.scaleY = e.item.dim.h / h;
      }

      bmp.on('mousedown', this.stageMouseDown);
      bmp.on('pressup', this.stageMouseUp);
      bmp.center = new createjs.Shape();
      bmp.center.graphics.beginFill('rgba(0,0,0,0.3)').drawCircle(0, 0, 25);
      bmp.center.x = bmp.x;
      bmp.center.y = bmp.y;
      bmp.center.visible = false;
      bmp.points = [];
      bmp.lines = 0;
      bmp.status = 0;

      this.images[e.item.gr].push(bmp);
      this.stage.addChild(bmp, bmp.center);
    },

    handleComplete(e) {
      var self = this;
      this.images.forEach(function (gr) {
        gr.forEach(function (bmp) {
          bmp.center.x += bmp.getTransformedBounds().width / 2;
          bmp.center.y += bmp.getTransformedBounds().height / 2;
          bmp.correct = self.findBmp(bmp.correct);
        });
      });

      this.stage.addChild(this.line);
      this.stage.addChild(this.point);
      this.stage.update();
    },
    stageMouseDown(e) {
      this.resetCheckStatus();
      var grx = -1;
      var ix = -1;

      this.images.forEach(function (gr, i) {
        gr.forEach(function (bmp, j) {
          if (e.target.id == bmp.id) {
            ix = j;
            grx = i;
          }
        });
      });

      if (ix >= 0 && grx >= 0 && !this.images[grx][ix].block) {
        this.stage.on('stagemousemove', this.stageMouseMove);
        this.point.x = e.stageX - this.offset.x;
        this.point.y = e.stageY - this.offset.y;
        this.point.visible = true;
        this.point.start = { gr: grx, i: ix };
        this.mousedown = true;
      }
      this.stage.update();
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        var pos = {
          x: e.stageX - this.offset.x,
          y: e.stageY - this.offset.y,
        };
        this.update(pos);
      }
    },
    stageMouseUp(e) {
      this.mousedown = false;
      this.point.visible = false;
      this.line.graphics.clear();
      var draw = -1;
      var self = this;
      var ix = -1,
        grx = -1;
      this.stage.getObjectsUnderPoint(self.point.x, self.point.y).forEach(function (bmp) {
        self.images.forEach(function (gr, i) {
          gr.forEach(function (indx, j) {
            if (indx.id == bmp.id) {
              ix = j;
              grx = i;
            }
          });
        });
      });
      if (ix >= 0 && grx != this.point.start.gr && !this.images[grx][ix].block) {
        this.images[this.point.start.gr][this.point.start.i].center.visible = true;
        this.images[grx][ix].center.visible = true;
        this.lines.forEach(function (item, j) {
          if (item.points.indexOf({ i: ix, gr: grx }) != -1 && item.points.indexOf(self.point.start) != -1) draw = j;
        });

        var line = {};
        if (draw == -1) line.shape = new createjs.Shape();
        else line = this.lines[draw];

        line.shape.graphics
          .clear()
          .s('black')
          .ss(2, 'round')
          .mt(this.images[grx][ix].center.x, this.images[grx][ix].center.y)
          .lt(
            this.images[this.point.start.gr][this.point.start.i].center.x,
            this.images[this.point.start.gr][this.point.start.i].center.y
          );
        line.shape.on('click', this.handleClickLine);
        line.points = [{ i: ix, gr: grx }, this.point.start];
        line.block = false;
        line.status = 0;

        this.lines.push(line);
        if (draw == -1) this.stage.addChild(line.shape);
      }
      this.stage.update();
      this.stage.removeAllEventListeners('stagemousemove');
    },
    handleClickLine(e) {
      this.resetCheckStatus();
      this.removeLine(e.currentTarget);
    },
    removeLine(cLine) {
      var ix = -1;
      this.lines.forEach(function (line, i) {
        if (line.shape == cLine) ix = i;
      });
      if (!this.lines[ix].block) {
        this.lines.splice(ix, 1);

        var self = this;
        this.images.forEach(function (gr, i) {
          gr.forEach(function (bmp, j) {
            if (bmp.center.visible) {
              var count = 0;
              self.lines.forEach(function (line) {
                if (
                  (line.points[0].i == j && line.points[0].gr == i) ||
                  (line.points[1].i == j && line.points[1].gr == i)
                )
                  count++;
              });
              bmp.center.visible = count > 0;
            }
          });
        });
        this.stage.removeChild(cLine);
      }
      this.stage.update();
    },
    update(newPos) {
      this.line.graphics
        .clear()
        .s('blue')
        .ss(2, 'round')
        .mt(
          this.images[this.point.start.gr][this.point.start.i].center.x,
          this.images[this.point.start.gr][this.point.start.i].center.y
        )
        .lt(newPos.x, newPos.y);
      this.point.x = newPos.x;
      this.point.y = newPos.y;
      this.stage.update();
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      var self = this;
      this.images.forEach(function (gr, i) {
        gr.forEach(function (bmp, j) {
          if (!bmp.block) {
            bmp.lines = 0;
            if (bmp.center.visible) {
              self.lines.forEach(function (line) {
                line.status = 0;
                if (
                  (line.points[0].gr == i && line.points[0].i == j) ||
                  (line.points[1].gr == i && line.points[1].i == j)
                ) {
                  bmp.lines++;
                }
              });
              bmp.status = bmp.lines == bmp.correct.length ? 2 : 1;
            }
          }
        });
      });

      this.images.forEach(function (gr, i) {
        gr.forEach(function (bmp, j) {
          if (!bmp.block) {
            if (!bmp.center.visible && bmp.correct.length > 0) isCorrect = false;
            if (bmp.center.visible) {
              var count = [];
              var cor = bmp.correct.length;
              self.lines.forEach(function (line, cL) {
                // start linii lub koniec linii jest na tym obrazku
                if (
                  (line.points[0].gr == i && line.points[0].i == j) ||
                  (line.points[1].gr == i && line.points[1].i == j)
                ) {
                  if (bmp.status == 1) line.status = 1;
                  count.push(cL);
                }
              });

              // jeżeli z obrazka wychodzi tyle linii ile powinno
              if (count.length == cor) {
                var c = 0;
                for (let k = 0; k < count.length; k++) {
                  let line = self.lines[count[k]];
                  if (
                    (line.points[0].gr == i &&
                      line.points[0].i == j &&
                      line.points[1].gr == bmp.correct[k].gr &&
                      line.points[1].i == bmp.correct[k].i) ||
                    (line.points[1].gr == i &&
                      line.points[1].i == j &&
                      line.points[0].gr == bmp.correct[k].gr &&
                      line.points[0].i == bmp.correct[k].i)
                  )
                    c++;
                }
                if (c != count.length) cor = 0;
                else {
                  // jeżeli linie wychodzące są prawdiłowe
                  for (let k = 0; k < count.length; k++) {
                    let line = self.lines[count[k]];
                    if (line.status == 0) line.status = 2;
                  }
                }
              }

              // jeżeli z obrazka wychodzi za dużo linii
              if (count.length > cor) {
                for (let k = 0; k < count.length; k++) {
                  let line = self.lines[count[k]];
                  line.status = 1;
                }
                isCorrect = false;
              }
            }
          }
        });
      });

      var flg = false;
      while (!flg) {
        var del = false;
        this.lines.forEach(function (line) {
          if (line.status == 1) {
            self.removeLine(line.shape);
            del = true;
          }
        });
        flg = !del;
      }

      this.lines.forEach(function (line) {
        if (line.status == 2) {
          line.shape.graphics
            .clear()
            .s('green')
            .ss(2, 'round')
            .mt(
              self.images[line.points[0].gr][line.points[0].i].center.x,
              self.images[line.points[0].gr][line.points[0].i].center.y
            )
            .lt(
              self.images[line.points[1].gr][line.points[1].i].center.x,
              self.images[line.points[1].gr][line.points[1].i].center.y
            );
          line.block = true;
          self.images[line.points[0].gr][line.points[0].i].block = true;
          self.images[line.points[1].gr][line.points[1].i].block = true;
          self.stage.update();
        }
      });

      return isCorrect;
    },
    findBmp(cor) {
      var finds = [];
      for (let i = 0; i < this.images.length; i++) {
        for (let j = 0; j < this.images[i].length; j++) {
          for (let k = 0; k < cor.length; k++) {
            if (this.images[i][j].id == cor[k]) finds.push(Object.assign({ gr: i, i: j }));
          }
        }
      }
      return finds;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
  },
  beforeDestroy() {
    this.stage.removeAllEventListeners();
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 1px solid black;
}

#game-container {
  margin: 0;
  border: 1px solid green;
  width: 100%;
  height: 100%;
}

canvas {
  border: 1px solid red;
}
</style>
